if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');

        this.addReadMore();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      addReadMore() {
        //This limit you can set after how much characters you want to show Read More.
        let characterLimit = 400;
        let readLessTxt = "... read less";
        let readMoreClassName = 'readMore';
        let readLessClassName = 'readLess';
        let hideReadMoreClassName = 'hideReadMore';
        let showReadMoreClassName = 'showReadMore'


        this.addReadMoreButton(characterLimit);

        this.querySelector(`.readMoreLink`).addEventListener('click', (evt) => {
          evt.preventDefault();
          console.log(`[Memphies] ReadMore Button clicked!`);
          let nodeList = this.querySelectorAll(`.${hideReadMoreClassName}`);
          nodeList.forEach((element, index) => {
            //console.log(`[Memphies] element: `, element)
            element.classList.remove(hideReadMoreClassName);
            element.classList.add(showReadMoreClassName);
          });
          // Remove Readmore element
          console.log(`[Memphies] QuerySelector`, this.querySelector(`.${readMoreClassName}`))
          this.querySelector(`.${readMoreClassName}`).remove();

          this.addReadLessButton();
          
          this.querySelector(`.readLessLink`).addEventListener('click', (evt) => {
            evt.preventDefault();
            console.log(`[Memphies] ReadLess Button clicked!`);
            this.addReadMoreButton(characterLimit);
          });
        });


      }

      addReadMoreButton(
        characterLimit = 300,
        buttonText = "Read more...",
        readMoreClassName = 'readMore',
        hideReadMoreClassName= 'hideReadMore',
        showReadMoreClassName = 'showReadMore'
      ) {
        let productDescription = this.querySelector('.product__description');
        let productText = this.stripHTML(productDescription.innerHTML);

        console.log(`[Memphies] Character count = ${productText.length}`)

        if (productText.length > characterLimit) {
          let totalLength = 0;
          let nodeNumberToAddReadMore = false;
          productDescription.childNodes.forEach((node, index) => {
            let length = this.stripHTML(node.textContent).length;
            totalLength = totalLength + length;
            //console.log(`[Memphies] Child Node ${index}, length: ${length} and totalLength: ${totalLength}`);

            if (nodeNumberToAddReadMore == false && totalLength >= characterLimit) {
              nodeNumberToAddReadMore = node;
            }
            if (nodeNumberToAddReadMore != false) {
              //console.log(`[Memphies] Adding hide class to node`, node);
              if (productDescription.childNodes[index].classList) {
                productDescription.childNodes[index].classList.add(hideReadMoreClassName);
                productDescription.childNodes[index].classList.remove(showReadMoreClassName);
              }
            }
          });

          let readMoreNode = document.createElement("span");
          readMoreNode.classList.add(readMoreClassName);
          readMoreNode.innerHTML = `<a href="#" class="readMoreLink">`+buttonText+`</a>`;

          productDescription.insertBefore(readMoreNode, nodeNumberToAddReadMore);
        }
      }

      addReadLessButton(
        readLessClassName = 'readLess',
        readLessTxt = '... Read Less'
      ) {
          // Add read less button
          let productDescription = this.querySelector('.product__description');
          let readLessNode = document.createElement("span");
          readLessNode.classList.add(readLessClassName);
          readLessNode.innerHTML = `<a href="#" class="readLessLink">`+readLessTxt+`</a>`;
          productDescription.appendChild(readLessNode);
      }

      stripHTML(str) {
        return str.replace(/(<([^>]+)>)/gi, "");
      }
    }
  );
}
